import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { ONBOARDING_STEPS } from '@forwardflow/constants/onboarding.constants'
import { IFooter, useFooter } from '../components/frame/footer-context'

/**
 * A setup step's action bar. Back goes to the previous step through the
 * store (which skips the paid steps once the subscription is active); it is
 * hidden on the first step and while a save is blocked.
 */
export const useStepFooter = (
   action: string,
   onAction: () => void,
   extra: Partial<IFooter> = {}
) => {
   const { getCurrentStep, getPreviousStep, onboardingSaveBlocked } =
      useOnboardingStoreV2()
   const step = getCurrentStep()
   const first = ONBOARDING_STEPS.indexOf(step) <= 0
   useFooter({
      action,
      onAction,
      back: first ? null : () => getPreviousStep(),
      ...extra,
      disabled: Boolean(extra.disabled) || Boolean(onboardingSaveBlocked),
   })
}
